/** ****************************************************
 *                                                    *
 *   EXAMPLE: Adding a new compiler kind              *
 *   Can also overwrite out of the box                *
 *     const: compileConst,                           *
 *     parameter: compileParameter,                   *
 *     getfield: compileFieldAccess,                  *
 *     nativecall: compileInvocation,                 *
 *     translate: compileTranslate,                   *
 *                                                    *
 ***************************************************** */

const { default: StandardAddressValidationUtil } = require('twia-capability-quoteandbind-residential-react/util/StandardAddressValidationUtil');
const { default: IsEastOfHwy146Util } = require('twia-capability-quoteandbind-residential-react/util/IsEastOfHwy146Util');
const { default: DwellingAnimalValidationUtil } = require('tfpa-capability-quoteandbind-residential-react/util/DwellingAnimalValidationUtil');
const { default: DwellingAdditionalInterestUtil } = require('tfpa-capability-quoteandbind-residential-react/util/DwellingAdditionalInterestUtil');
const { default: AgentRegistrationValidationUtil } = require('../../../../common/capabilities-react/ent-capability-agentregistration-react/utils/AgentRegistrationValidationUtil');
const { default: Requiredness } = require('../../../../common/modules/twia-portals-viewmodel-js/aspects/Requiredness');


// const compileParameter = (expr) => {
//    const paramIdx = expr.index;
//    return (args) => {
//        return args[paramIdx];
//    };
// }
// const getaspect = {
//    compileInvocation: () => {
//        return (expr, buildContext) => {
//            console.log(expr);
//            console.log(buildContext);
//        }
//    }
// }

/** ****************************************************
 *                                                    *
 *   EXAMPLE: Adding a new Expression Language Type   *
 *   Declare a new Expression Language Type           *
 *                                                    *
 ***************************************************** */
/**
 * It is used to configure backend validations
 * Optional namespace for Expression Type
 * Required Expression Language Object which should contain function properties that correspond to your backend Expression Object
 */
// US26354 Added to enable left navigation for Residential Quote Flow
const standardAddressValidationUtil = {
    namespace: 'pc',
    type: {
        'meetsAddressStandardizationReqs': (a, b, c, country) => {
            if (a && country?.code === 'US') {
                return b || c;
            }

            return true;
        }
    }
}


const twiaAgentRegistrationValidationUtil = {
    namespace: 'pc',
    type: {

        'equalStrings': (thisString, thatString) => {
            return (
                thisString &&
                thatString &&
                thisString === thatString);
        },
        'ensureDocsLength': (bankAccountNumber, docs) => {
            if (!bankAccountNumber) {
                return true;
            }
            return (bankAccountNumber && (docs.length > 0));
        },
        'isNotBlank': (src) => {
            if (!src) {
                return true;
            }
            if (typeof src === 'string') {
                return src.trim().length === 0;
            }
        },
        'trueIfNotBlank': (aVal, anotherVal) => {
            if (_.isNull(aVal) || _.isEmpty(aVal)) {
                return true;
            }
            return ((anotherVal) && (aVal && aVal.trim().length > 0));
        },
    }
}

// US26344
const twiYourHomeUtil = {
    namespace: 'pc',
    type: {
        'ensureAntennaSecured': (currentValue, structureType) => {
            if (structureType && structureType.code === 'AntennaDish') {
                return currentValue === true;
            }

            return true;
        }
    }
}
// DE15711 Added International postal code validation
const twiaValidationFunctions = {
    namespace: 'pc',
    type: {
        'optionalVisibility_TWIA': (cond, target) => {
            return cond ? target : 'OPTIONAL';
        },
        'validatePostalCode_TWIA': (country, postalCode) => {
            if (postalCode) {
                switch (country.code) {
                    case 'US':
                        return postalCode.match(/^[0-9]{5}(-[0-9]{4})?$/) !== null;
                    case 'AU':
                        return postalCode.match(/^[0-9]{4}$/) !== null;
                    case 'CA':
                        return postalCode.match(/^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY][0-9][a-zA-Z] [0-9][a-zA-Z][0-9]$/) !== null;
                    case 'DE':
                        return postalCode.match(/^[0-9]{5}$/) !== null;
                    case 'FR':
                        return postalCode.match(/^[0-9]{5}$/) !== null;
                    case 'GB':
                        return postalCode.match(/.+/) !== null;
                    case 'JP':
                        return postalCode.match(/^[0-9]{3}-[0-9]{4}$/) !== null;
                    default:
                        return true;
                }
            }
        }
    }
}

const searchClaimsDateValidationUtil = {
    namespace: 'cc',
    type: {
        'isFromDateGreaterThanOrEqualToTDateExt': (toDate, fromDate) => {
            return fromDate && toDate && toDate.getTime() >= fromDate.getTime();
        }
    }
}

/** *************************************
 *                                     *
 *   EXAMPLE - creating a new aspect   *
 *                                     *
 ************************************** */

// const myaspect = {
//    getAspectProperties: (currentViewModelNode, currentMetadataNode, ancestorChain) => {
//        const { aspectAttribute } = currentMetadataNode;
//        const { value } = currentViewModelNode;
//
//        const isPatternApplied = value === maskInfo.pattern;
//        return {
//            aspectInfo1: {
//                get: () => !!aspectAttribute?.aspectInfo1 === 'a value';
//            },
//            isVisible: {
//                get: () => !!aspectAttribute?.aspectInfo2 < 42;
//            },
//        };
//    }
// }

/** **************************************************************
 *                                                              *
 *   EXAMPLE - creating a new ExpressionLanguage aware aspect   *
 *                                                              *
 *************************************************************** */

// const myELAwareAspect = {
//     create: (expressionLanguage) => {
//         // compute parameters based on the expression language
//         return {
//             getAspectProperties: (currentViewModelNode, currentMetadataNode, ancestorChain) => {
//                 return {
//                     property1: {
//                         get: () => ''; // Replace with desired value
//                     }
//                 }
//             }
//         }
//     }
// }

/** **************************************
 *                                      *
 *   EXAMPLE - Importing a new aspect   *
 *                                      *
 *************************************** */

// PLEASE NOTE THE .default is important here
// const AvailableValues = require('./AvailableValues').default;
const validationFunctions = require('../../../../common/modules/twia-portals-viewmodel-js').default;

const compareDate = (d1, d2) => new Date(d1).getTime() - new Date(d2).getTime();
/**
 * DE10655 compare a javascript date against a local date
 */
const compareLocalDate = (d1, d2) => {
    const simpleDate = new Date(d2.year, d2.month, d2.day);
    return new Date(d1).getTime() - simpleDate.getTime();
}

const getContextValue = (context, prop) => {
    return context(prop);
}
/** ************************************************
 *                                                *
 *   EXAMPLE - Adding a new Validation function   *
 *                                                *
 ************************************************* */

// const exampleArrLength = (a) => {
//     return a ? a.length : 0;
// }



// Export Expression Types and Validation Functions
module.exports = {
    // add different types of aspects with or without expression language
    // NOTE you can override existing aspects by providing its name as the key for the object entry
    aspectFactory: {
        // myELAwareAspect: myELAwareAspect.create,
        // myaspect: () => myaspect
        myAspectTWIA: Requiredness.create
    },
    // Types
    // Key should match the backend package name for your Expression Object
    // Value should be your new Expression Language Type
    types: {
        // DE15200 - moved validations to util file
        'org.tfpa.edge.capabilities.agent.util.AgentRegistrationValidationUtil': {
            namespace: 'pc',
            type: AgentRegistrationValidationUtil
        },
        // US26340 Added to enable the new quote flow
        'org.twia.util.TWIADateUtil': {
            namespace: 'pc',
            type: validationFunctions.TWIADateUtil
        },
        'org.tfpa.edge.capabilities.address.dto.validation.util.StandardAddressValidationUtil': standardAddressValidationUtil,
        // US26344
        'org.twia.edge.capabilities.address.dto.validation.util.StandardAddressValidationUtil': {
            namespace: 'pc',
            type: StandardAddressValidationUtil
        },
        'org.twia.edgev1001.capabilities.address.dto.validation.util.StandardAddressValidationUtil': {
            namespace: 'cc',
            type: StandardAddressValidationUtil
        },
        // eslint-disable-next-line no-secrets/no-secrets
        'org.twia.edge.capabilities.policyjob.lob.homeowners.coverables.dto.TWIAYourHomeDTOUtil': twiYourHomeUtil,
        // US26488 validates expression logic for PaymentpreferenceDTO 
        'org.twia.elevate.edge.capabilities.agent.util.AgentRegistrationValidationUtil': twiaAgentRegistrationValidationUtil,
        // eslint-disable-next-line no-secrets/no-secrets
        'org.enterprise.edge.capabilities.common.dto.util.ENTIsEastOfHwy146Util': {
            namespace: 'pc',
            type: IsEastOfHwy146Util
        },
        // eslint-disable-next-line no-secrets/no-secrets
        'org.tfpa.edge.capabilities.common.dto.util.IsEastOfHwy146Util': {
            namespace: 'pc',
            type: IsEastOfHwy146Util
        },
        // eslint-disable-next-line no-secrets/no-secrets
        'org.tfpa.edge.capabilities.quote.submission.lob.homeowners.coverables.dto.validation.DwellingAnimalValidationUtil': {
            namespace: 'pc',
            type: DwellingAnimalValidationUtil
        },
        // eslint-disable-next-line no-secrets/no-secrets
        'org.tfpa.edge.capabilities.policychange.lob.homeowners.coverables.dto.validation.DwellingAdditionalInterestUtil': {
            namespace: 'pc',
            type: DwellingAdditionalInterestUtil
        },
        'org.twia.edge.aspects.validation.TWIAValidationFunctions': twiaValidationFunctions,
        // eslint-disable-next-line no-secrets/no-secrets
        'ext.TWIA.edge.capabilities.claim.dto.util.TWIAClaimSearchDTOValidationUtil': searchClaimsDateValidationUtil,

    },
    // Validations
    // Function name should match backend validation function
    validations: {
        compareLocalDate,
        compareDate,
        getContextValue
        // exampleArrLength,

    },
    validationMessagesToIgnore: [
        // validation messages that the view model surfaces that Jutro might duplicate

        // This field is required
        'displaykey.Edge.Web.Api.Model.NotNull',
        // Value entered must be a valid phone number
        'displaykey.Edge.Web.Api.Model.Phone',

    ],
    kindCompilers: {
        // getaspect1: compileParameter,
        // getaspect2: getaspect.compileAspectAccess(),
        // parameter: compileParameter
    },
};
